(() => {
  if (window.fvNavigationInstalled) return;
  window.fvNavigationInstalled = true;
  let sequence = 0;
  const desktop = window.matchMedia('(min-width: 961px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(header) {
    if (header.dataset.navigationReady) return;
    header.dataset.navigationReady = 'true';
    const branches = [...header.querySelectorAll('.fv-menu-branch')];
    const mobile = header.querySelector('[data-fv-mobile-menu]');
    const menus = [...branches, ...(mobile ? [mobile] : [])];
    const timers = new Map();
    const openedByHover = new WeakSet();
    const summary = (menu) => menu.querySelector(':scope > summary');
    const panel = (menu) => menu.querySelector(':scope > .fv-menu-panel');
    const cancel = (menu) => { clearTimeout(timers.get(menu)); timers.delete(menu); };
    function close(menu) {
      cancel(menu);
      openedByHover.delete(menu);
      menu.open = false;
      summary(menu)?.setAttribute('aria-expanded', 'false');
      menu.querySelectorAll('details').forEach((child) => {
        cancel(child);
        openedByHover.delete(child);
        child.open = false;
        summary(child)?.setAttribute('aria-expanded', 'false');
      });
    }
    function fit(menu) {
      const box = panel(menu);
      if (!box || !desktop.matches) return;
      box.classList.remove('is-flipped', 'is-scrollable');
      box.style.removeProperty('--fv-menu-max-height');
      if (box.getBoundingClientRect().right > document.documentElement.clientWidth - 12) box.classList.add('is-flipped');
      // Leaf lists can scroll on short screens; parent lists retain visible flyouts.
      const bounds = box.getBoundingClientRect();
      if (!box.querySelector('.fv-menu-branch') && bounds.bottom > window.innerHeight - 12) {
        box.style.setProperty('--fv-menu-max-height', `${Math.max(100, window.innerHeight - bounds.top - 12)}px`);
        box.classList.add('is-scrollable');
      }
    }
    function open(menu) {
      cancel(menu);
      const list = menu.parentElement.parentElement;
      list.querySelectorAll(':scope > li > details[open]').forEach((other) => { if (other !== menu) close(other); });
      menu.open = true;
      summary(menu)?.setAttribute('aria-expanded', 'true');
      fit(menu);
    }
    const closeAll = () => menus.forEach(close);

    menus.forEach((menu) => {
      const trigger = summary(menu);
      const content = menu.querySelector(':scope > ul, :scope > nav, :scope > div.fv-menu-panel');
      if (content) {
        content.id ||= `fv-nav-panel-${++sequence}`;
        trigger?.setAttribute('aria-controls', content.id);
      }
      trigger?.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => {
        trigger?.setAttribute('aria-expanded', String(menu.open));
        if (!menu.open) {
          menu.querySelectorAll('details[open]').forEach(close);
        } else if (menu !== mobile) {
          fit(menu);
        }
      });
      trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        if (menu.open && openedByHover.has(menu)) openedByHover.delete(menu);
        else if (menu.open) close(menu);
        else if (menu === mobile) { menu.open = true; trigger.setAttribute('aria-expanded', 'true'); }
        else open(menu);
      });
    });

    branches.forEach((menu) => {
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !desktop.matches || !hover.matches) return;
        if (!menu.open) openedByHover.add(menu);
        open(menu);
      });
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || !desktop.matches || !hover.matches) return;
        cancel(menu);
        timers.set(menu, setTimeout(() => {
          if (!menu.contains(document.activeElement)) close(menu);
        }, 220));
      });
    });
    header.addEventListener('click', (event) => {
      if (event.target.closest('nav a')) closeAll();
    });
    header.addEventListener('focusout', () => {
      setTimeout(() => {
        menus.filter((menu) => menu.open && !menu.contains(document.activeElement) && !menu.matches(':hover')).forEach(close);
      }, 0);
    });
    header.addEventListener('keydown', (event) => {
      const target = event.target;
      const menu = target.closest(event.key === 'Escape' ? 'details[open]' : 'details');
      if (!menu || !menus.includes(menu)) return;
      if (event.key === 'Escape' || (event.key === 'ArrowLeft' && menu.classList.contains('fv-menu-branch') && !menu.classList.contains('fv-menu-branch--root'))) {
        event.preventDefault();
        close(menu);
        summary(menu)?.focus();
      } else if ((event.key === 'ArrowDown' || event.key === 'ArrowRight') && target === summary(menu) && menu !== mobile) {
        event.preventDefault();
        open(menu);
        panel(menu)?.querySelector('a, summary')?.focus();
      }
    });
    const outside = (event) => { if (!header.contains(event.target)) closeAll(); };
    document.addEventListener('pointerdown', outside);
    const resize = () => closeAll();
    desktop.addEventListener('change', resize);
    const unload = (event) => {
      if (!event.target.contains(header)) return;
      document.removeEventListener('pointerdown', outside);
      desktop.removeEventListener('change', resize);
      timers.forEach(clearTimeout);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  const start = (root) => root.querySelectorAll('[data-fv-navigation]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
